<template>
  <van-row class="home_banner">
    <van-col span="12">
      <van-row>
        <van-col span="24" v-if="noticeCard1.display" style="padding-right: 10px;">
          <img :src="noticeCard1.url" alt="" @click="goToPath(noticeCard1.redirectUrl)">
        </van-col>
        <van-col span="24" v-if="noticeCard2.display" style="padding-right: 10px;">
          <img :src="noticeCard2.url" alt="" @click="goToPath(noticeCard2.redirectUrl)">
        </van-col>
      </van-row>
    </van-col>
    <van-col span="12" v-if="noticeCard3.display">
      <img :src="noticeCard3.url" alt="" @click="goToPath(noticeCard3.redirectUrl)">
    </van-col>
  </van-row>
</template>

<script setup lang="ts">
import { BannerItem, useNavigation } from '@/view/home/supportScript';
import { computed } from 'vue'

const { goToPath } = useNavigation()

const props = defineProps<{
  itemData: {
    noticeData?: Record<string, Record<string, BannerItem>>
    notice1?: BannerItem
    notice2?: BannerItem
    notice3?: BannerItem
  }
}>()

const noticeCard1 = computed(() => {
  if (props.itemData.noticeData) {
    const lang = localStorage.getItem('lang') || 'en'
    const data = props.itemData.noticeData[lang] || props.itemData.noticeData['en'] || {}
    return data.notice1 || { url: '', redirectUrl: '', display: false }
  }
  return props.itemData.notice1 || { url: '', redirectUrl: '', display: false }
})
const noticeCard2 = computed(() => {
  if (props.itemData.noticeData) {
    const lang = localStorage.getItem('lang') || 'en'
    const data = props.itemData.noticeData[lang] || props.itemData.noticeData['en'] || {}
    return data.notice2 || { url: '', redirectUrl: '', display: false }
  }
  return props.itemData.notice2 || { url: '', redirectUrl: '', display: false }
})
const noticeCard3 = computed(() => {
  if (props.itemData.noticeData) {
    const lang = localStorage.getItem('lang') || 'en'
    const data = props.itemData.noticeData[lang] || props.itemData.noticeData['en'] || {}
    return data.notice3 || { url: '', redirectUrl: '', display: false }
  }
  return props.itemData.notice3 || { url: '', redirectUrl: '', display: false }
})
</script>
<style scoped>
.home_banner img {
  width: 100%;
  border-radius: 9px;
  padding: 5px 0 2px 0px;
}
</style>